import { LitElement, css } from 'lit';
import { customElement } from 'lit/decorators.js';

import './pages/app-home';
import './components/header';
import './styles/global.css';
import { router } from './router';

@customElement('app-index')
export class AppIndex extends LitElement {
  static styles = css`
    main {
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 16px;
    }
  `;

  firstUpdated() {
    router.addEventListener('route-changed', () => {
      if ('startViewTransition' in document) {
        (document as any).startViewTransition(() => this.requestUpdate());
      } else {
        this.requestUpdate();
      }
    });
  }

  render() {
    // router config can be round in src/router.ts
    return router.render();
  }
}

console.log('Testing build-trigger 1');
console.log('Testing build-trigger 2');
console.log('Testing build-trigger 3');
console.log('Testing build-trigger 4');
console.log('Testing build-trigger 5');
console.log('Testing build-trigger 6');
console.log('Testing build-trigger 7');
console.log('Testing body parser');
console.log('Testing buffer payload');
console.log('Testing buffer payload 2');
console.log('Testing new Staging branch 1');
